import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

import classes from './Property.module.css';

import MaterialDatePicker from '../Core/MaterialDatePicker/MaterialDatePicker';
import MaterialDropDown from '../Core/MaterialDropDown/MaterialDropDown';

const TimeSlot = ({ timeSlotOptions, onSlotOptionsChange, onDeleteTimeSlot, slotIndex }) => {
  const timeOptions = [
    { text: 'Morning', value: 'Morning' },
    { text: 'Afternoon', value: 'Afternoon' },
  ];
  const timeZoneOptions = [{ text: 'EST', value: 'EST' }];

  const onDateChange = (value) =>
    onSlotOptionsChange({ ...timeSlotOptions, selectedDate: value.getTime() });
  const onTimeChange = (value) => onSlotOptionsChange({ ...timeSlotOptions, selectedTime: value });
  const onTimeZoneChange = (value) =>
    onSlotOptionsChange({ ...timeSlotOptions, selectedZone: value });

  return (
    <div className={classes.timeSlot} style={{ width: slotIndex == 0 ? '94.4%' : '' }}>
      <MaterialDatePicker
        selectedDate={timeSlotOptions.selectedDate}
        onChange={onDateChange}
      ></MaterialDatePicker>
      <MaterialDropDown
        label="Choose slot*"
        options={timeOptions}
        onChange={onTimeChange}
        selectedValue={timeSlotOptions.selectedTime}
      ></MaterialDropDown>
      {slotIndex !== 0 && (
        <IconButton edge="end" aria-label="delete" onClick={onDeleteTimeSlot}>
          <DeleteIcon className={classes.deleteIcon} />
        </IconButton>
      )}
    </div>
  );
};

export default TimeSlot;
